export default function deepClone<T>(obj: T): T {
  // Handle primitives and null/undefined
  if (obj === null || typeof obj !== "object") {
    return obj;
  }

  // Handle Arrays
  if (Array.isArray(obj)) {
    return obj.map((item) => deepClone(item)) as unknown as T;
  }

  // Handle Date
  if (obj instanceof Date) {
    return new Date(obj.getTime()) as unknown as T;
  }

  // Handle Map
  if (obj instanceof Map) {
    const mapCopy = new Map();
    obj.forEach((value, key) => {
      mapCopy.set(deepClone(key), deepClone(value));
    });
    return mapCopy as unknown as T;
  }

  // Handle Set
  if (obj instanceof Set) {
    const setCopy = new Set();
    obj.forEach((value) => {
      setCopy.add(deepClone(value));
    });
    return setCopy as unknown as T;
  }

  // Handle Objects
  const clonedObj = {} as T;
  for (const key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      (clonedObj as any)[key] = deepClone((obj as any)[key]);
    }
  }

  return clonedObj;
}
